// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"239":"ffb832cd5f696fcccb7a","245":"c0dfd523f0c3439c6563"}[chunkId] + ".js";
};